"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import _ from "underscore";
import DocumentThumbnail from "./document_thumbnail";
import reactUtils from "../react_utils";
import "../components/waiting_spinner";
import Auth from "../util/auth";
import { doctypeGroupings } from "./grouped_document_browser_model";
import {
  documentHasReferenceMatchForLoad,
  documentHasMissingReferenceMatchForLoad,
  isPodForLoad
} from "./helpers/document_load_relationship_helpers";
import Account from "../api/account";
var bem = reactUtils.makeBem("document-thumbnail-list");
var RelatedDocumentList = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "RelatedDocumentList",
        className: bem("related-container")
      },
      /* @__PURE__ */ React.createElement("div", { className: bem("related-container-title") }, this.props.title),
      this.waitingSpinner(this.props.loading),
      this.props.documents.map(this.showDocument)
    );
  },
  waitingSpinner: function(loading) {
    if (loading) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-thumbnail--loading" }, "Loading...");
    }
  },
  showDocument: function(document) {
    const hasReferenceMatch = false;
    const missingReferenceMatch = false;
    const isPod = document.is_pod;
    return /* @__PURE__ */ React.createElement(
      DocumentThumbnail,
      {
        document,
        key: document.id,
        variant: this.props.variant,
        onContextMenu: this.props.onContextMenu,
        pageSelected: this.props.pageSelected,
        selectedPages: this.props.selectedPages,
        isDocumentGrouper: this.props.isDocumentGrouper,
        hasReferenceMatch,
        missingReferenceMatch,
        isPodForLoad: isPod
      }
    );
  }
});
export default React.createClass({
  renderEntries: function() {
    if (this.props.isDocumentGrouper || !Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled) {
      return _.map(
        this.documentsInSelectedGroups(),
        this.showDraggableThumbnailGroup
      );
    }
    const documentsInGroups = this.documentsInSelectedGroups();
    const documentTypes = _.groupBy(
      documentsInGroups,
      (document) => document[0].type
    );
    const sortedDocumentTypes = doctypeGroupings(this.props.documents);
    const entries = sortedDocumentTypes.map((type) => {
      var _a, _b, _c, _d;
      const groupedDocuments = documentTypes[type].sort(
        (a, b) => a[0].id - b[0].id
      );
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: ((_d = (_c = (_b = (_a = Auth) == null ? void 0 : _a._currentUser) == null ? void 0 : _b.account) == null ? void 0 : _c.settings) == null ? void 0 : _d.documents_viewer_doctype_grouping_enabled) ? "document-browser__grouped-by-doctype" : ""
        },
        /* @__PURE__ */ React.createElement("div", { className: "document-thumbnail__title document-thumbnail__doctype" }, groupedDocuments[0][0].type_name),
        _.map(groupedDocuments, this.showDraggableThumbnailGroup)
      );
    });
    return entries;
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem(this.props.variant) }, this.renderEntries(), this.possibleRelatedDocuments());
  },
  documentsInSelectedGroups: function() {
    let currentArray = [];
    const component = this;
    return _.reduce(
      this.props.documents,
      (memo, document) => {
        const isSelected = _.find(
          component.selectedPages(),
          (page) => page.id === document.pages[0].id
        );
        if (isSelected) {
          currentArray.push(document);
          if (currentArray.length === component.selectedPages().length) {
            memo.push(currentArray);
            currentArray = [];
          }
        } else {
          memo.push([document]);
        }
        return memo;
      },
      []
    );
  },
  showDraggableThumbnailGroup: function(documents) {
    const key = "documents-" + documents.map((document) => document.id).join("-");
    return /* @__PURE__ */ React.createElement("div", { className: "draggable-thumbnail-group", key }, _.map(documents, this.showDocument));
  },
  showDocument: function(document) {
    const load = this.props.selectedLoad || this.props.loadState;
    let hasReferenceMatch = false;
    let missingReferenceMatch = false;
    if (Account.currentSettings().pod_requires_bol_validation) {
      hasReferenceMatch = documentHasReferenceMatchForLoad(
        document,
        load,
        this.props.documentLoadRelationships
      );
      missingReferenceMatch = documentHasMissingReferenceMatchForLoad(
        document,
        load,
        this.props.documentLoadRelationships
      );
    }
    const isPod = isPodForLoad(
      document,
      load,
      this.props.documentLoadRelationships
    );
    return /* @__PURE__ */ React.createElement(
      DocumentThumbnail,
      {
        document,
        key: document.id,
        variant: this.props.variant,
        onContextMenu: this.props.onContextMenu,
        pageSelected: this.pageSelected,
        selectedPages: this.selectedPages(),
        isDocumentGrouper: this.props.isDocumentGrouper,
        hasReferenceMatch,
        missingReferenceMatch,
        isPodForLoad: isPod
      }
    );
  },
  noSelectedPages: function() {
    const pages = this.props.documents.map((document) => document.pages[0]);
    return _.isEmpty(_.intersection(pages, this.selectedPages()));
  },
  pageSelected: function(selectedPage, options = {}) {
    const { action } = options;
    if (action === "replace" || this.noSelectedPages()) {
      this.setSelectedPages([selectedPage], selectedPage);
    } else if (action === "add") {
      const pages = this.props.documents.map((document) => document.pages[0]);
      const anchorPageIndex = pages.indexOf(this.props.anchorPage);
      const selectedPageIndex = pages.indexOf(selectedPage);
      let minIndex = anchorPageIndex;
      let maxIndex = selectedPageIndex;
      if (selectedPageIndex < anchorPageIndex) {
        minIndex = selectedPageIndex;
        maxIndex = anchorPageIndex;
      }
      const selectedPages = pages.slice(minIndex, maxIndex + 1);
      this.setSelectedPages(selectedPages, this.props.anchorPage);
    }
  },
  setSelectedPages: function(selectedPages, anchorPage) {
    this.props.setSelectedPages(selectedPages, anchorPage);
  },
  selectedPages: function() {
    return this.props.selectedPages;
  },
  possibleRelatedDocuments: function() {
    if (this.props.relatedDocuments && this.props.relatedDocuments.length > 0) {
      return /* @__PURE__ */ React.createElement(
        RelatedDocumentList,
        __spreadProps(__spreadValues({}, this.props), {
          pageSelected: this.pageSelected,
          selectedPages: this.selectedPages(),
          loading: this.props.relatedDocumentsLoading,
          documents: this.props.relatedDocuments,
          title: this.props.relatedDocumentsTitle
        })
      );
    }
  }
});
